import { motion } from 'framer-motion';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    gap: 20px;
    align-items: center;
    width: 100%;
    overflow-x: auto;

    @media (max-width: 917px) {
        gap: 5px;
    }
`;

export const TabLink = styled(NavLink)`
    position: relative;
    padding: 30px 10px;

    color: rgba(255, 255, 255, 0.5);
    font-size: 18px;
    font-weight: 700;
    line-height: 100%;

    display: flex;
    align-items: end;
    justify-content: center;
    gap: 8px;

    transition: color 0.2s ease-in-out;

    &.active {
        color: #fff;
    }

    @media (max-width: 917px) {
        font-size: 16px;
        font-weight: 600;
    }
`;

export const ActiveLine = styled(motion.div)`
    width: 100%;
    height: 2px;
    background-color: #fff;

    position: absolute;
    bottom: 0;
    left: 0;
    margin-top: 1px;
`;

export const Divider = styled.div`
    width: 1px;
    height: 21px;
    background: rgba(255, 255, 255, 0.25);
    transform: translateY(2px);
    margin: 0 10px;

    @media (max-width: 917px) {
        display: none;
    }
`;

export const Count = styled.div`
    color: #fff;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 1px;

    border-radius: 100px;
    background: #f00;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 16px;
    height: 16px;

    position: absolute;
    top: 22px;
    right: -7px;

    pointer-events: none;
`;
